import React, { useEffect, useRef, useState } from "react";
import { TableWrapper } from "../../Components/styledConstant";
import LocalLoader from "../../Components/Loader/LocalLoader";
import { FilterWrapper } from "../../assets/styles/FilterStyle";
import { AlertWrapper } from "../../assets/styles/AlerWrapper";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
import companylogo from "../../assets/images/companylogo.png";
import DatePicker from "react-datepicker";
import Pagination from "../../Components/Pagination/Pagination";
import {
  getDateFromDateObj,
  isAlphabet,
  isEmpty,
  isNumber,
} from "../../utils/common";
import animationData1 from "../../assets/lotties/question.json";
import { assignedDeviceList, unassignDevice } from "../../utils/api";
import ModalData from "../../Components/ModalData/ModalData";
import DateRangePicker from "../../Components/DateRangePicker/DateRangePicker";

const AssignedDeviceList = () => {
  const [downloadLoader, setDownloadLoader] = useState("");
  const [showfilter, setShowFilter] = useState("");
  const [fromDate, setStartDate] = useState("");
  const [toDate, setEndDate] = useState("");
  const [currPage, setCurrPage] = useState(0);
  const [totalElements, setTotalElements] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(null);
  const [deviceId, setDeviceId] = useState("");
  const [userName, setUserName] = useState("");
  const [deviceName, setDeviceName] = useState("");
  const [unassignedDevice, setUnassignedDevice] = useState("");
  const [assignDevice, setAssignDevice] = useState();
  const [pdfData, setPdfData] = useState([]);
  const [status, setStatus] = useState("ACTIVE");
  const [message, setMessage] = useState();
  const link = useRef();

  const defaultOptions1 = {
    loop: true,
    autoplay: true,
    animationData: animationData1,
  };

      const clearRef = useRef(null);
  const clearDate = (callback) => {
    if (clearRef.current) return;
    clearRef.current = callback;
  };

  const constChangeDate = (startDate, endDate) => {
    if (endDate) {
      setEndDate(endDate);
      setStartDate(startDate);
    }
  };

  const onClearDate = () => {
    setEndDate("");
    setStartDate("");
  };

  var currentDate = new Date();
  var formattedDate = [
    currentDate.getDate(),
    currentDate.getMonth() + 1,
    currentDate.getFullYear(),
  ]
    .map((n) => (n < 10 ? `0${n}` : `${n}`))
    .join("-");

  const handleDetailData = (e, key = "") => {
    const value = e.target.value;
    const name = e.target.name;
    // if (key === "number") {
    //   if (!isNumber(value) && !isEmpty(value)) return;
    //   if (name === "deviceId") {
    //     setDeviceId(e.target.value);
    //   }
    // }
    if (key === "number") {
      if (!isNumber(value) && !isEmpty(value)) return;
      if (name === "userName") {
        setUserName(e.target.value);
      }
    }
    if (key === "text") {
      if (!isAlphabet(value) && !isEmpty(value)) return;
      if (name === "deviceName") {
        setDeviceName(e.target.value);
      }
    }
    if (key === "") {
      if (name === "deviceId") {
        setDeviceId(e.target.value);
      }
    }
  };

  let _fromDate = "";
  let _toDate = "";

  if (fromDate !== "" && toDate !== "") {
    _fromDate = getDateFromDateObj(fromDate, "YYYY-MM-DD");
    _toDate = getDateFromDateObj(toDate, "YYYY-MM-DD");
  }
  const handleAssignDevice = async (e, key) => {
    const param = {
      fromDate: _fromDate,
      toDate: _toDate,
      status: status,
    };

    const pagination = {
      currentPage: currPage,
      pageSize: pageSize,
    };
    if (key === "CSV" || key === "PDF") {
      if (key === "CSV") {
        setDownloadLoader("CSV");
      } else {
        setDownloadLoader("PDF");
      }
      pagination.pageSize = totalElements;
      pagination.currentPage = 0;
    }
    if (key === "search") {
      pagination.currentPage = 0;
      setCurrPage(0);
    } else {
      setLoading(true);
    }
    if (key === "refresh") {
      dataRefresh();
      param.fromDate = "";
      param.toDate = "";
      pagination.currentPage = 0;
      setCurrPage(0);
    } else {
      setLoading(true);
    }
    let pageNo = currPage;
    let size = pageSize;
    if (key === "CSV" || key === "PDF") {
      pageNo = 0;
      size = totalElements;
    }

    assignedDeviceList(param, pageNo, size).then((resp) => {
      setLoading(false);
      setDownloadLoader("");
      if (resp?.data.success) {
        if (key === "CSV") {
          setPdfData(resp?.data?.data?.content);
          setTimeout(() => {
            const csvlink = link.current;
            csvlink.link.click();
          }, 100);
        } else if (key === "PDF") {
          userlistPdfData(resp?.data?.data?.content);
        } else {
          setAssignDevice(resp?.data?.data?.content);
          setTotalPages(resp?.data?.data?.totalPages);
          setTotalElements(resp?.data?.data?.totalElements);
        }
      }
    });
  };
  useEffect(() => {
    handleAssignDevice();
  }, [status]);

  const dataRefresh = () => {
    setStartDate("");
    setEndDate("");
    setCurrPage(0);
    setStatus("ACTIVE");
       if (clearRef.current) {
      clearRef.current();
    }
  };

  const userlistPdfData = (data = []) => {
    let _width = 350; // Width of the custom size
    const height = 297;
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm", // units: mm, cm, in, px
      format: [_width, height],
      compress: true,
      putOnlyUsedFonts: true,
      precision: 16, // n
    });
    //Add image in PDF header
    const imgWidth = 25;
    const imgHeight = 9;
    const leftXPos = 14;
    const yPos = 2;
    doc.addImage(companylogo, "PNG", leftXPos, yPos, imgWidth, imgHeight);

    //Add fileName in the center
    const text = "Inventory List";
    // Calculate the width of the text
    const textWidth =
      (doc.getStringUnitWidth(text) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    // Get the width of the PDF
    const pdfWidth = doc.internal.pageSize.width;
    const yPos1 = 10;
    // Calculate the X position for center alignment
    const centerXPos = (pdfWidth - textWidth) / 2;
    doc.text(text, centerXPos, yPos1);
    const generalFontSize = 12;
    doc.setFontSize(generalFontSize);
    const dateWidth =
      (doc.getStringUnitWidth(formattedDate) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    const rightXPos = pdfWidth - dateWidth - 15; // 10 is for some margin from the right edge
    doc.text(formattedDate, rightXPos, yPos1);
    const tableData = [];
    data.forEach((item, index) => {
      const rowData = [
        index + 1,
        item?.userName,
        item?.serialNo,
        item?.deviceType,
        item?.status,
        item?.terminalId,
      ]; // Customize as needed
      tableData.push(rowData);
    });

    doc.autoTable({
      head: [
        [
          "S.No",
          "Retailer Name",
          "Device Id",
          "device Type",
          "Status",
          "Terminal Id",
        ],
      ], // Customize table header
      body: tableData,
    });

    doc.save("inventoryList.pdf");
  };

  //delete Device

  const deleteDevice = (userId) => {
    setUnassignedDevice(userId);
  };

  const unAssignDevice = (userId) => {
    setUnassignedDevice();
    unassignDevice(userId).then((resp) => {
      if (resp?.data?.success) {
        setMessage({
          msg: "Device status changed successfully.",
          type: "success",
        });
        setTimeout(() => {
          setUnassignedDevice();
          setMessage();
        }, 2000);
        handleAssignDevice();
      } else {
        let msg = "";
        if (resp?.data?.errorCodeList.length > 0) {
          setMessage({ msg: msg, type: "error" });
        } else {
          setMessage({ msg: msg, type: "error" });
        }
      }
    });
  };
  return (
    <div>
      {message && (
        <AlertWrapper className="success globle">
          <span className="close" onClick={() => setMessage("")}>
            ×
          </span>
          {message.msg}
        </AlertWrapper>
      )}
      <div className="" style={{ padding: "30px" }}>
        <div className="userlist_head">
          <div className="userlist_heading">
            <div className="userlist_left">
              <label>Assigned POS List</label>
            </div>
            <div className="userlist_right">
              {downloadLoader !== "PDF" ? (
                <button
                  className="pdf"
                  onClick={(e) => handleAssignDevice(e, "PDF")}
                >
                  PDF
                </button>
              ) : (
                <button className="pdf">
                  <div className="btn-loader">
                    <i className="fa-solid fa-spinner"></i>
                  </div>
                </button>
              )}

              {downloadLoader !== "CSV" ? (
                <button
                  className="xls"
                  onClick={(e) => handleAssignDevice(e, "CSV")}
                >
                  CSV
                </button>
              ) : (
                <button className="xls">
                  <div className="btn-loader">
                    <i className="fa-solid fa-spinner"></i>
                  </div>
                </button>
              )}
              <CSVLink
                ref={link}
                data={pdfData}
                filename="InventoryList.csv"
              ></CSVLink>
            </div>
            <div className="userlist_filter">
              <button
                className="filter fs-16"
                onClick={(e) =>
                  showfilter === "active"
                    ? setShowFilter("")
                    : setShowFilter("active")
                }
              >
                <i className="fa-solid fa-filter"></i>
              </button>
            </div>
          </div>
        </div>
        <FilterWrapper
          style={{ height: "auto" }}
          className={`display_data ${showfilter}`}
        >
          <div className="filterBox">
            <div style={{width:"100%"}}>
              <div className="flex align-items gap-15">
                <div>
                  <input
                    type="text"
                    name="deviceId"
                    placeholder="Enter device id"
                    value={deviceId}
                    onChange={(e) => handleDetailData(e, "")}
                    // maxLength={10}
                  />
                </div>
                <div>
                  <input
                    type="text"
                    name="userName"
                    placeholder="Enter username"
                    value={userName}
                    onChange={(e) => handleDetailData(e, "number")}
                    maxLength={10}
                  />
                </div>
                {/* <div className="input-field">
                  <select
                    onChange={(e) => setStatus(e.target.value)}
                    value={status}
                    className="input_select_field"
                  >
                    <option value={null} selected>
                      Status
                    </option>
                    <option value="ACTIVE">Active</option>
                    <option value="INACTIVE">InActive</option>
                    <option value="MAPPED">Mapped</option>
                  </select>
                </div> */}
                {/* <div className="input-field">
                  <div className="flex">
                    <DatePicker
                      showIcon
                      className="date-picker2 date_type"
                      placeholderText="From Date"
                      selected={fromDate}
                      selectsStart
                      startDate={fromDate}
                      endDate={toDate}
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown={true}
                      showYearDropdown
                      onKeyDown={(e) => e.preventDefault()}
                      onChange={(date) => setStartDate(date)}
                      maxDate={new Date()}
                    />
                  </div>
                </div>
                <div className="input-field">
                  <div className="flex">
                    <DatePicker
                      showIcon
                      className="date-picker2 date_type"
                      placeholderText="To Date"
                      selected={toDate}
                      selectsEnd
                      startDate={fromDate}
                      endDate={toDate}
                      minDate={fromDate}
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown={true}
                      showYearDropdown
                      onKeyDown={(e) => e.preventDefault()}
                      onChange={(date) => setEndDate(date)}
                      maxDate={new Date()}
                    />
                  </div>
                </div> */}
                  <DateRangePicker
                    applyDate={constChangeDate}
                    defaultDate={null}
                    onClear={onClearDate}
                    clearDate={clearDate}
                  />
                <div className="button">
                  <button
                    className="userlist_btn"
                    onClick={(e) => handleAssignDevice(e, "search")}
                  >
                    Search
                  </button>
                </div>
                <div className="button">
                  <button
                    className="refresh-btn"
                    onClick={(e) => handleAssignDevice(e, "refresh")}
                  >
                    <i className="fa fa-refresh"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </FilterWrapper>

        {
          <div className="table-loader">
            {loading && <LocalLoader className="tableLoader" />}
            <TableWrapper className="table-card-wrapper">
              <table className="table">
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Retailer Name</th>
                    <th>Device Id</th>
                    <th>Device Name</th>
                    <th>Device type</th>
                    <th>Terminal No</th>
                    <th>Created Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {assignDevice?.map((item, index = 1) => {
                    const dateTimeString = item?.createDate;
                    let [date, time] = dateTimeString.split("T");
                    let newTime = time.slice(0, 8);
                    return (
                      <tr>
                        <td className="td-none">
                          <span className="card-th">Sr No</span>
                          <span>{index + 1}</span>
                        </td>

                        <td className="pointer">
                          <span className="card-th">Retailer Name</span>
                          <span
                          //  className="tooltip" data-tooltip={item?.retailerName || "Diwakar Upadhyay"}
                           >{item?.userName || "-"}</span>

                        </td>
                        <td>
                          <span className="card-th">Device Id</span>
                          <span>{item?.serialNo || "-"}</span>
                        </td>
                        <td>
                          <span className="card-th">Device Name</span>
                          <span>{item?.deviceName || "-"}</span>
                        </td>
                        <td>
                          <span className="card-th">Device type</span>
                          <span>{item?.deviceType || "-"}</span>
                        </td>
                        <td>
                          <span className="card-th">Terminal No</span>
                          <span>{item?.terminalId || "-"}</span>
                        </td>
                        <td>
                          <span className="card-th">Created Date</span>
                          <span>{date + " " + newTime}</span>
                          {/* <span>{item?.createDate}</span> */}
                        </td>
                        <td>
                          <span className="card-th">Status</span>
                          <span>
                            <div
                              className={`${
                                item.status == "ACTIVE"
                                  ? "active_status"
                                  : "inactive_status"
                              }`}
                            >
                              {item?.status || "-"}
                            </div>
                          </span>
                        </td>

                        <td className="user_action_btn">
                          <span className="card-th">Actions</span>
                          <span className="center flex gap-10">
                            {/* <div
                              className={`custom-toggle toggle_button ${
                                item.status === "ACTIVE" ? "active" : ""
                              }`}
                              onClick={() =>
                                updateUserStatus(item.uuid, item.status)
                              }
                            >
                              <div className="slider"></div>
                            </div> */}

                            <button onClick={() => deleteDevice(item?.uuid)}>
                              <i className="fa-solid fa-circle-xmark unassign"></i>
                            </button>
                          </span>
                        </td>
                      </tr>
                    );
                  })}

                  {!loading && assignDevice && assignDevice.length < 1 && (
                    <tr>
                      <td
                        colSpan={6}
                        style={{ textAlign: "center", color: "red" }}
                      >
                        No data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </TableWrapper>
          </div>
        }
         <div style={loading ? { opacity: "0" } : { opacity: "1" }}>
        {totalPages > 1 && (
          <Pagination
            items={assignDevice}
            itemsPerPage={pageSize}
            setitemsPerPage={setPageSize}
            currentPage={currPage}
            setcurrentPage={setCurrPage}
            totalPages={totalPages}
          />
        )}
      </div>
      </div>
     
      {!isEmpty(unassignedDevice) && (
        <ModalData
          onClickCancel={() => setUnassignedDevice(null)}
          onClickConfirm={() => unAssignDevice(unassignedDevice)}
          lottieOptions={defaultOptions1}
          heading1="Are you sure you want to unassign this device from the user?"
        />
      )}
    </div>
  );
};

export default AssignedDeviceList;
